import { alpha, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => {
  const darkMode = theme.palette.type === 'dark';
  const summaryBorder = alpha(theme.palette.primary.main, darkMode ? 0.35 : 0.16);

  return {
    container: {
      height: '100%',
    },
    summaryStrip: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      background: alpha(theme.palette.primary.main, darkMode ? 0.12 : 0.06),
      border: `1px solid ${summaryBorder}`,
      borderRadius: '16px',
      overflow: 'hidden',
      [theme.breakpoints.down('sm')]: {
        gridTemplateColumns: '1fr',
      },
    },
    summaryCell: {
      padding: '18px 24px',
      '&:not(:last-child)': {
        borderRight: `1px solid ${summaryBorder}`,
        [theme.breakpoints.down('sm')]: {
          borderRight: 'none',
          borderBottom: `1px solid ${summaryBorder}`,
        },
      },
    },
    summaryLabel: {
      fontSize: '12px',
      fontWeight: 500,
      letterSpacing: '0.3px',
      color: theme.palette.primary.main,
      marginBottom: 4,
    },
    summaryValue: {
      fontSize: '16px',
      fontWeight: 600,
      color: theme.palette.text.primary,
    },
    card: {
      padding: '26px 28px',
      borderRadius: '20px',
      position: 'relative',
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2),
      },
    },
    cardTitle: {
      fontSize: '19px',
      fontWeight: 600,
      letterSpacing: '-0.2px',
      color: theme.palette.text.primary,
    },
    cardSubtitle: {
      fontSize: '13px',
      lineHeight: '20px',
      color: theme.palette.text.secondary,
    },
    cardDivider: {
      height: 1,
      backgroundColor: theme.palette.divider,
    },
    twoColRow: {
      display: 'grid',
      gridTemplateColumns: '3fr 2fr',
      gap: theme.spacing(3),
      alignItems: 'start',
      [theme.breakpoints.down('sm')]: {
        gridTemplateColumns: '1fr',
      },
    },
    equalRow: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: theme.spacing(3),
      alignItems: 'start',
      [theme.breakpoints.down('md')]: {
        gridTemplateColumns: '1fr',
      },
    },
    notificationRow: {
      display: 'grid',
      gridTemplateColumns: '220px 1fr 1fr auto',
      gap: theme.spacing(2),
      alignItems: 'center',
      [theme.breakpoints.down('sm')]: {
        gridTemplateColumns: '1fr',
        alignItems: 'stretch',
      },
    },
    notificationRowMonthly: {
      display: 'grid',
      gridTemplateColumns: '220px 1fr auto',
      gap: theme.spacing(2),
      alignItems: 'center',
      [theme.breakpoints.down('sm')]: {
        gridTemplateColumns: '1fr',
        alignItems: 'stretch',
      },
    },
    notificationLabel: {
      fontSize: '15px',
      fontWeight: 600,
      color: theme.palette.text.primary,
    },
    bold: {
      fontWeight: 600,
    },
    regularBold: {
      fontWeight: 400,
    },
    smallText: {
      fontSize: '13px',
      lineHeight: '22px',
    },
    moduleName: {
      fontWeight: 600,
      color: theme.palette.primary.main,
      marginLeft: '4px',
    },
    bigTitle: {
      fontWeight: 600,
      color: '#fff',
    },
    openDialogText: {
      cursor: 'pointer',
    },
    gridContainer: {
      alignItems: 'center',
    },
    addButton: {
      height: 57,
      width: 57,
      marginLeft: theme.spacing(1),
    },
    inviteLink: {
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
    },
    schedule: {
      border: `1px solid ${theme.palette.divider}`,
      padding: theme.spacing(2),
      borderRadius: '8px',
    },
    wrapper: {
      padding: theme.spacing(3),
      minHeight: 86,
      borderRadius: '8px',
      position: 'relative',
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2),
      },
    },
    separator: {
      borderRight: `1px solid ${theme.palette.text.secondary}`,
      height: '15px',
      margin: '3px 16px 0',
    },
    input: {
      display: 'none',
    },
    resultWrapper: {
      border: '1px solid #EFF0F7',
      borderRadius: '8px',
      width: '150px',
      padding: theme.spacing(2),
    },
    errorButton: {
      borderColor: theme.palette.error.main,
      color: theme.palette.error.main,
    },
    errorBadge: {
      backgroundColor: theme.palette.error.main,
    },
    redButton: {
      color: theme.palette.error.main,
    },
    moduleContainer: {
      padding: '24px 40px',
      [theme.breakpoints.down('xs')]: {
        padding: theme.spacing(1),
      },
    },
    filterWrapper: {
      marginRight: '40px',
      maxWidth: '320px',
      width: '100%',
      backgroundColor: theme.palette.background.paper,
      '& .MuiInputBase-root': {
        backgroundColor: theme.palette.background.paper,
      },
      [theme.breakpoints.down('sm')]: {
        maxWidth: 'unset',
        marginRight: 'unset',
        padding: '16px',
      },
    },
    tabsWrapper: {
      backgroundColor: theme.palette.background.paper,
      [theme.breakpoints.down('md')]: {
        marginLeft: '-16px',
        marginRight: '-16px',
      },
    },
    checkboxLabel: {
      fontWeight: 500,
      fontSize: '13px',
      color: theme.palette.text.secondary,
    },
  };
});
